"use client";
import "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { EnabledFlow } from "@getpara/web-sdk";
import { InnerStepContainer, StepContainer } from "../common.js";
import { CpslIcon, CpslSpinner, CpslTab, CpslTabs } from "@getpara/react-components";
import { OnRampStep } from "../../stores/index.js";
import { useModalStore } from "../../stores/modal/useModalStore.js";
import { useEffect, useMemo } from "react";
import { useActiveWallet } from "../../hooks/useActiveWallet.js";
import { getAddFundsStep } from "../../utils/steps.js";
import styled from "styled-components";
import { AddFundsProvider } from "./AddFundsProvider.js";
import { AddFundsReceive } from "./AddFundsReceive.js";
import { AddFundsContextProvider, TABS } from "./AddFundsContext.js";
import { AnimatePresence } from "framer-motion";
import { AddFundsSettings } from "./AddFundsSettings.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const AddFunds = () => {
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const onRampStep = useModalStore((state) => state.onRampStep);
  const storedTab = useModalStore((state) => state.accountAddFundTab);
  const setModalStep = useModalStore((state) => state.setStep);
  const setOnRampPurchase = useModalStore((state) => state.setOnRampPurchase);
  const para = useInternalClient();
  const activeWallet = useActiveWallet();
  const canBuyAndWithdraw = !!para.userId;
  const tabs = TABS.filter(
    ([, key]) => !!(onRampConfig == null ? void 0 : onRampConfig[key]) && (["isBuyEnabled", "isWithdrawEnabled"].includes(key) && canBuyAndWithdraw || !["isBuyEnabled", "isWithdrawEnabled"].includes(key))
  );
  const tab = storedTab != null ? storedTab : tabs[0][0];
  const isMultiFlow = tabs.length > 1;
  const onSetTab = (event) => {
    setModalStep(getAddFundsStep(event.detail.tab));
  };
  const Content = useMemo(() => {
    switch (tab) {
      case EnabledFlow.BUY:
      case EnabledFlow.WITHDRAW: {
        switch (onRampStep) {
          case OnRampStep.SETTINGS:
            return /* @__PURE__ */ jsx(AddFundsSettings, {});
          case OnRampStep.PROVIDER:
            return /* @__PURE__ */ jsx(AddFundsProvider, {});
        }
      }
      default:
        return /* @__PURE__ */ jsx(AddFundsReceive, {});
    }
  }, [onRampStep, tab]);
  useEffect(() => {
    setOnRampPurchase(void 0);
  }, []);
  if (!onRampConfig || !activeWallet) {
    return /* @__PURE__ */ jsx(SpinnerContainer, { children: /* @__PURE__ */ jsx(CpslSpinner, {}) });
  }
  return /* @__PURE__ */ jsxs(StepContainer, { children: [
    isMultiFlow && /* @__PURE__ */ jsx(InnerStepContainer, { children: /* @__PURE__ */ jsx(CpslTabs, { selectedTab: tab, onCpslTabsChanged: onSetTab, children: TABS.map(([tab2, _, icon, title]) => /* @__PURE__ */ jsxs(CpslTab, { tab: tab2, children: [
      /* @__PURE__ */ jsx(CpslIcon, { slot: "start", icon }),
      title
    ] }, tab2)) }) }),
    /* @__PURE__ */ jsx(AnimatePresence, { mode: "wait", children: /* @__PURE__ */ jsx(AddFundsContextProvider, { "data-testid": "add-funds", tab, children: Content }) })
  ] });
};
const SpinnerContainer = styled(StepContainer)`
  margin: 50% 0;
`;
export {
  AddFunds
};
